import { useTranslation } from 'react-i18next';
import { PerformanceDashboard } from '../../types/dashboard.types';

export interface KpiStripProps {
  dashboard: PerformanceDashboard;
}

const formatCurrency = (value?: number) =>
  value === undefined ? '-' : new Intl.NumberFormat(undefined, { style: 'currency', currency: 'CHF' }).format(value);

export const KpiStrip = ({ dashboard }: KpiStripProps) => {
  const { t } = useTranslation();

  const tiles = [
    { label: t('FINAL_SCORE'), value: dashboard.FinalScore.toFixed(1) },
    { label: t('RATING'), value: t(dashboard.RatingBandLabel) },
    { label: t('PORTFOLIO_REVENUE'), value: formatCurrency(dashboard.PortfolioRevenueActual) },
  ];

  return (
    <div className="flex flex-wrap gap-3">
      {tiles.map((tile) => (
        <div key={tile.label} className="min-w-40 max-w-full flex-1 rounded-md border bg-card px-4 py-3 [overflow-wrap:anywhere]">
          <p className="text-xs text-muted-foreground">{tile.label}</p>
          <p className="text-base font-semibold">{tile.value}</p>
        </div>
      ))}
    </div>
  );
};
